import en from './en/index.js'

export default () => en
